
<template>

  <svg viewBox="0 0 68 68" aria-hidden="true">

    <path d="m51.7 10.2 1.3 6.7h2.8l-1.5-8.2c-0.2-1-1.1-1.6-2.1-1.4l-47.2 9c-1 0.2-1.6 1.1-1.4 2.1l7.7 40.4c0.1 0.5 0.4 0.9 0.8 1.2v-11.5l-5.6-29.7z"
    
      fill="currentColor" />

    <path d="m63.5 18.6h-48c-1 0-1.8 0.8-1.8 1.8v41.1c0 1 0.8 1.8 1.8 1.8h48c1 0 1.8-0.8 1.8-1.8v-41.2c-0.1-0.9-0.8-1.7-1.8-1.7zm-1 41.2h-46v-38.5h46z"
    
      fill="currentColor" />

    <path d="m60.9 45.1-10.8-5.4c-0.6-0.4-1.3-0.4-1.9 0l-6.9 4.8-8.5-10.1c-0.3-0.4-0.8-0.6-1.2-0.6-0.5 0-0.9 0.2-1.2 0.6l-12.3 10.2v13.6h42.9v-13.1z"
    
      fill="currentColor" />

    <circle transform="rotate(-13.3386)" cx="43.1807" cy="38.902" r="3.69991" stroke-width=".999976"  fill="currentColor" />

  </svg>

</template>
